import { Password } from 'primereact/password';

const AIEduPassword = (props) => {
    const { title, titleStyle, width } = props;
    return (
        <div
            className='mt-3'
            style={{
                display: 'flex',
                flexDirection: 'column',
                gap: '10px',
                width,
            }}
        >
            <label htmlFor={title} className={titleStyle}>
                {title}
            </label>
            <Password {...props} />
        </div>
    );
};

export default AIEduPassword;
